import isAdminOwnerSuperAdmin from '../isAdminOwnerSuperAdmin';
import isProgramManager from '../isProgramManager';
import isProgramTrainer from '../isProgramTrainer';
import isStudent from '../isStudent';
import isTeacher from '../isTeacher';

export default function canAccessTurbineAdmin(role = [], orgType = '') {
  if (
    isTeacher(role) ||
    isProgramManager(role) ||
    isProgramTrainer(role) ||
    isAdminOwnerSuperAdmin(role)
  ) {
    return true;
  }

  if (isStudent(role) && orgType === 'workforce') {
    return true;
  }

  return false;
}
